module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.screenTrack[0] >= 2) ? _c('router-link', {
    staticClass: "rout-bot bot-left hvr-grow",
    attrs: {
      "aria-label": "Página anterior",
      "to": '/' + _vm.mod.modurl + '/' + (_vm.screenTrack[0] - 1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nextPant) ? _c('router-link', {
    staticClass: "rout-bot bot-right hvr-grow",
    attrs: {
      "aria-label": "Página siguiente",
      "to": '/' + _vm.mod.modurl + '/' + (_vm.screenTrack[0] + 1)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6e6d09e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Navbuttons.vue
// module id = 1054
// module chunks = 1